import React from 'react';
import BookForm from './components/BookForm/BookForm';
import Header from './components/Header/Header';

function App() {
  return (
    <>
      <Header />
      <BookForm />
    </>
  );
}

export default App;
